import { render } from "./MaterialSymbolsPage.vue?vue&type=template&id=6e0d7d40&ts=true"
import script from "./MaterialSymbolsPage.vue?vue&type=script&lang=ts"
export * from "./MaterialSymbolsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__